export var tabType;
(function (tabType) {
    tabType["readMain"] = "readMain";
    tabType["read"] = "read";
    tabType["reply"] = "reply";
    tabType["replyAll"] = "replyAll";
    tabType["forward"] = "forward";
    tabType["writeCommon"] = "common";
    tabType["replyWithAttach"] = "replyWithAttach";
    tabType["replyAllWithAttach"] = "replyAllWithAttach";
    tabType["forwardAsAttach"] = "forwardAsAttach";
    tabType["edit"] = "edit";
    tabType["editDraft"] = "editDraft";
    tabType["temp"] = "temp";
    tabType["customer"] = "customer";
    tabType["subordinate"] = "subordinate";
    tabType["replyAllAsNew"] = "replyAllAsNew";
})(tabType || (tabType = {}));
export var MAIL_LOAD_STATUS;
(function (MAIL_LOAD_STATUS) {
    MAIL_LOAD_STATUS["SUCCESS"] = "SUCCESS";
    MAIL_LOAD_STATUS["FAIL"] = "FAIL";
    MAIL_LOAD_STATUS["LOADING"] = "LOADING";
    MAIL_LOAD_STATUS["EMPTY"] = "EMPTY";
})(MAIL_LOAD_STATUS || (MAIL_LOAD_STATUS = {}));
